<div class="alert alert-danger nt-4" *ngIf="serverErrorMessages">
  <strong>Erro no servidor:</strong>
  <ul>
    <li *ngFor="let error of serverErrorMessages">{{error}}</li>
  </ul>
</div>
